export default "__VITE_ASSET__7d1c34d5__"